import React from 'react';

function IconBrokenSuitcase() {
  return (
    <svg fill="none" viewBox="0 0 361 360">
      <rect width="360" height="360" x="0.324" fill="#fff" rx="8" />
      <circle cx="180.324" cy="180" r="144" fill="#FFEADE" />
      <circle cx="180.324" cy="180" r="144" fill="#FFEADE" />
      <g clipPath="url(#clip0)">
        <path
          fill="#010101"
          d="M95.04 357.912l-3.7-.665c-1.613-.284-2.657-1.803-2.278-3.416l2.088-10.817 6.547 1.233-2.656 13.665zm2.847.57l3.7.664c1.614.285 3.132-.759 3.417-2.277l2.087-10.818-6.547-1.234-2.657 13.665z"
        />
        <path
          fill="#fff"
          stroke="#010101"
          strokeMiterlimit="10"
          strokeWidth="0.949"
          d="M105.953 349.562l-14.993-2.847c-.854-.19-1.328-.759-1.233-1.423l2.562-13.285 17.934 3.416-2.562 13.285c-.095.664-.854 1.043-1.708.854z"
        />
        <path
          stroke="#010101"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M143.434 174.677l19.262-100.679 71.738 13.76-19.358 100.678"
        />
        <path
          stroke="#010101"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M147.23 175.437l19.358-100.68L230.64 87l-19.358 100.774"
        />
        <path
          fill="#FF7020"
          d="M266.983 181.13l-29.701 154.957c-2.941 15.562-18.029 25.715-33.591 22.774l-112.73-21.635c-15.563-2.942-25.716-18.03-22.774-33.592l29.796-154.957c2.941-15.562 18.029-25.715 33.591-22.773l112.635 21.635c15.562 2.941 25.716 18.029 22.774 33.591z"
        />
        <path
          fill="#010101"
          d="M235.763 92.787L159.66 78.174l1.898-9.869c.949-4.934 5.693-8.16 10.628-7.212l58.263 11.197c4.934.95 8.16 5.694 7.211 10.628l-1.897 9.869z"
        />
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          d="M94.85 301.072c-1.233-.19-2.087-1.423-1.803-2.657l25.905-135.03c.19-1.233 1.424-2.087 2.657-1.803 1.234.19 2.088 1.424 1.803 2.657l-25.905 135.03c-.19 1.234-1.423 2.088-2.657 1.803zm94.984 17.649c-1.233-.189-2.087-1.423-1.802-2.657l25.905-135.029c.19-1.234 1.423-2.088 2.657-1.803 1.233.189 2.087 1.423 1.803 2.657l-25.906 135.029c-.189 1.234-1.423 2.088-2.657 1.803zm23.821 4.46c-1.234-.19-2.088-1.423-1.803-2.657l25.905-135.029c.19-1.234 1.423-2.088 2.657-1.803 1.234.189 2.088 1.423 1.803 2.657l-25.905 135.029a2.33 2.33 0 01-2.657 1.803zm-47.543-8.824c-1.234-.19-2.088-1.423-1.803-2.657l25.905-135.03c.19-1.233 1.423-2.087 2.657-1.803 1.234.19 2.088 1.424 1.803 2.657l-25.905 135.03c-.19 1.234-1.424 1.993-2.657 1.803zm-47.539-8.825c-1.234-.19-2.088-1.424-1.803-2.657l25.905-135.03c.19-1.233 1.423-2.087 2.657-1.803 1.234.19 2.088 1.424 1.803 2.657l-25.905 135.03c-.19 1.233-1.424 1.993-2.657 1.803zm23.816 4.365c-1.233-.19-2.087-1.423-1.803-2.657l25.811-135.03c.189-1.233 1.423-2.087 2.656-1.803 1.234.19 2.088 1.424 1.803 2.657l-25.81 135.03c-.285 1.234-1.423 2.088-2.657 1.803z"
        />
        <path
          fill="#010101"
          d="M291.656 351.934v3.7a2.957 2.957 0 01-2.942 2.942h-11.007v-6.642h13.949zm0-2.942v-3.701a2.956 2.956 0 00-2.942-2.941h-11.007v6.642h13.949z"
        />
        <path
          fill="#fff"
          stroke="#010101"
          strokeMiterlimit="10"
          strokeWidth="0.949"
          d="M281.409 342.729v15.277c0 .855-.57 1.519-1.139 1.519h-13.285a4.9 4.9 0 01-4.934-4.935v-8.255a4.9 4.9 0 014.934-4.934h13.285c.569-.19 1.139.569 1.139 1.328z"
        />
        <path
          fill="#010101"
          d="M253.796 348.138h-1.234l1.044 4.46h1.139l-.949-4.46zm2.184 0h-1.234l1.044 4.46h1.139l-.949-4.46zm-4.369 0h-1.138l.949 4.46h1.138l-.949-4.46zm-2.179 0h-1.139l.949 4.46h1.233l-1.043-4.46zm9.677 0l.949 4.46h2.088v-4.46h-3.037zm-11.862 0h-.759v4.46h1.803l-1.044-4.46zm10.912 0h-1.233l.949 4.46h1.233l-.949-4.46z"
        />
        <path stroke="#010101" strokeMiterlimit="10" d="M70.844 359.525H304.94" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h237.227v299.096H0z" transform="translate(67.71 60.904)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IconBrokenSuitcase;
